import type { ReactNode } from 'react';
import type { OrgSummary } from '@aiai/shared';

/**
 * The label above a workspace's group of items on a cross-workspace list —
 * workspace name + its `/slug`, with an optional right-aligned count. Makes it
 * obvious which workspace each block of projects/prototypes belongs to.
 */
export function WorkspaceGroupHeader({
  workspace,
  right,
}: {
  workspace: OrgSummary;
  right?: ReactNode;
}) {
  return (
    <div className="mb-2 flex items-center gap-2 px-1">
      <span className="text-sm font-medium text-ink">{workspace.name}</span>
      <span className="font-mono text-2xs text-ink-faint">/{workspace.slug}</span>
      {right !== undefined && (
        <span className="ml-auto font-mono text-2xs tabular-nums text-ink-muted">
          {right}
        </span>
      )}
    </div>
  );
}
